import Modal, { FullHeightModalContent } from '../../../components/Modal';
import { ParagraphLargeText } from '../../../components/Texts';
import PhoneVerificationForm from '../../../components/PhoneVerificationForm';
import { useState } from 'react';

const VerifyPhoneNumberModal = ({ onClose, onContinue }) => {
  const [fullyRendered, setFullyRendered] = useState(false);

  return (
    <Modal onClose={onClose} onDidPresent={() => setFullyRendered(true)}>
      <FullHeightModalContent>
        <ParagraphLargeText style={{ textAlign: 'center', width: '100%' }}>
          Deposit
        </ParagraphLargeText>
        <PhoneVerificationForm
          onVerified={onContinue}
          showTitle={false}
        />
      </FullHeightModalContent>
    </Modal>
  );
};

export default VerifyPhoneNumberModal;
